<div class="w-full mx-auto p-5 space-y-5">

  <!-- ============================================================ -->
  <!-- Header consolidado                                            -->
  <!-- ============================================================ -->
  <div class="flex flex-wrap items-end justify-between gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Personas</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Proveedores</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Proveedores</h1>
      <p class="text-sm text-slate-500 mt-1 tabular-nums">
        {{ totalThirdParties }} registrados · Información de terceros y proveedores para egresos
      </p>
    </div>

    <a routerLink="/third-partie/new" class="btn btn-primary">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      Nuevo Proveedor
    </a>
  </div>

  <!-- ============================================================ -->
  <!-- KPIs unificados                                               -->
  <!-- ============================================================ -->
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">

    <div class="kpi-card kpi-sky">
      <div class="kpi-label">
        <span class="kpi-icon"><i class="fas fa-users"></i></span>
        Total Registrados
      </div>
      <div class="kpi-value">{{ totalThirdParties }}</div>
      <div class="kpi-hint">Proveedores en el sistema</div>
    </div>

    <div class="kpi-card kpi-emerald">
      <div class="kpi-label">
        <span class="kpi-icon"><i class="fas fa-check-circle"></i></span>
        Activos
      </div>
      <div class="kpi-value">{{ activeThirdParties }}</div>
      <div class="w-full bg-slate-100 rounded-full h-1 mt-1" *ngIf="totalThirdParties > 0">
        <div class="bg-emerald-500 h-1 rounded-full transition-all"
          [style.width.%]="(activeThirdParties / totalThirdParties) * 100"></div>
      </div>
      <div class="kpi-hint tabular-nums">
        {{ totalThirdParties > 0 ? ((activeThirdParties / totalThirdParties) * 100 | number:'1.0-1') : 0 }}% del total
      </div>
    </div>

    <div class="kpi-card kpi-rose">
      <div class="kpi-label">
        <span class="kpi-icon"><i class="fas fa-ban"></i></span>
        Inactivos / Bajas
      </div>
      <div class="kpi-value">{{ inactiveThirdParties }}</div>
      <div class="kpi-hint tabular-nums">
        {{ totalThirdParties > 0 ? ((inactiveThirdParties / totalThirdParties) * 100 | number:'1.0-1') : 0 }}% del total
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Toolbar de filtros                                            -->
  <!-- ============================================================ -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <div class="col-span-12 md:col-span-9">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none"
            stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()"
            placeholder="Buscar por nombre, documento o correo..."
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <div class="col-span-12 md:col-span-3">
        <p-dropdown [options]="statusDropdownOptions" [(ngModel)]="statusFilter" (onChange)="onStatusFilterChange()"
          styleClass="w-full" placeholder="Estado" optionLabel="label" optionValue="value" [showClear]="true"
          appendTo="body" panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Tabla                                                         -->
  <!-- ============================================================ -->
  <div class="rounded-xl border border-slate-200 bg-white overflow-x-auto">
    <table class="enrollment-table">
      <thead>
        <tr>
          <th>Proveedor</th>
          <th>Documento</th>
          <th>Contacto</th>
          <th>Estado</th>
          <th>Auditoría</th>
          <th class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>

        <!-- Empty state -->
        <tr *ngIf="!thirdParties || thirdParties.length === 0">
          <td colspan="6" class="text-center py-10">
            <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
              <i class="fas fa-users text-slate-400 text-lg"></i>
            </div>
            <p class="text-sm font-medium text-slate-700">No hay proveedores registrados</p>
            <a routerLink="/third-partie/new" class="btn btn-secondary btn-sm mt-3 inline-flex">
              <i class="fas fa-plus"></i> Agregar proveedor
            </a>
          </td>
        </tr>

        <tr *ngFor="let thirdParty of thirdParties" [class.opacity-60]="thirdParty.isDeleted">

          <!-- Proveedor -->
          <td>
            <a [routerLink]="['/third-parties/profile-third-party/', thirdParty.id]" target="_blank"
              class="participant-cell group">
              <div class="initials-avatar"
                [ngClass]="'tone-' + getInitialsTone(thirdParty.commercialName || thirdParty.firstName)">
                {{ getInitials(thirdParty.firstName, thirdParty.lastName, thirdParty.commercialName) }}
              </div>
              <div class="participant-meta">
                <div class="participant-name">
                  {{ getDisplayName(thirdParty) }}
                  <svg class="external-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </div>
                <div class="participant-email" *ngIf="getSecondaryInfo(thirdParty)">{{ getSecondaryInfo(thirdParty) }}</div>
                <div class="participant-email tabular-nums">ID #{{ thirdParty.id }}</div>
              </div>
            </a>
          </td>

          <!-- Documento -->
          <td>
            <div class="doc-cell">
              <span class="doc-type">{{ thirdParty.typeDocument }}</span>
              <span class="doc-number">{{ thirdParty.documentId }}</span>
            </div>
          </td>

          <!-- Contacto -->
          <td>
            <div class="contact-cell">
              <span class="contact-line" *ngIf="thirdParty.email">
                <i class="fas fa-envelope"></i>
                <span class="truncate max-w-[200px]" [title]="thirdParty.email">{{ thirdParty.email }}</span>
              </span>
              <span class="contact-line tabular-nums" *ngIf="thirdParty.cellPhone || thirdParty.phone">
                <i class="fas fa-phone"></i>
                {{ thirdParty.cellPhone || thirdParty.phone }}
              </span>
              <span class="contact-empty" *ngIf="!thirdParty.email && !thirdParty.cellPhone && !thirdParty.phone">
                Sin contacto
              </span>
            </div>
          </td>

          <!-- Estado -->
          <td>
            <span class="pill" [ngClass]="thirdParty.isDeleted ? 'pill-neutral' : 'pill-emerald'">
              <span class="w-1.5 h-1.5 rounded-full"
                [ngClass]="thirdParty.isDeleted ? 'bg-slate-400' : 'bg-emerald-500'"></span>
              {{ thirdParty.isDeleted ? 'Inactivo' : 'Activo' }}
            </span>
          </td>

          <!-- Auditoría -->
          <td>
            <app-audit-info [auditData]="{
              createdBy: thirdParty.createdBy,
              createdAt: thirdParty.createdAt,
              updatedBy: thirdParty.updatedBy,
              updatedAt: thirdParty.updatedAt
            }" layout="compact" size="sm">
            </app-audit-info>
          </td>

          <!-- Acciones -->
          <td class="text-right">
            <div class="inline-flex items-center gap-1">
              <a [routerLink]="['/third-parties/profile-third-party/', thirdParty.id]"
                class="row-action row-action--primary" title="Ver perfil">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                </svg>
                <span>Ver</span>
              </a>
              <a [routerLink]="['/third-partie/view/', thirdParty.id]" class="row-action" title="Editar">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487z" />
                </svg>
                <span>Editar</span>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginador -->
  <div *ngIf="thirdParties && thirdParties.length > 0" class="bg-white rounded-xl border border-slate-200">
    <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 50, 100]"
      (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first}–{last} de {totalRecords}">
    </p-paginator>
  </div>

</div>
